import React from 'react';

import { Footer } from 'components';
import clsx from 'clsx';
import styles from './PageLayout.module.css';

const PageLayout = ({ children, padded, showFooter = true }) => {
  return (
    <div className={styles.pageLayout}>
      <div className={clsx(styles.content, { [styles.paddedContent]: padded })}>{children}</div>
      {showFooter && <Footer />}
    </div>
  );
};

export default PageLayout;
